import React from "react";
import { Form, Select } from "antd";

const FormSelectColor = ({
  label,
  name,
  rules,
  options,
  placeholder,
  style = undefined,
  size = "large",
  onChange,
  ...rest
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={rules}
    {...rest}
    className="custom-select"
  >
    <Select
      placeholder={placeholder}
      size={size}
      style={style}
      options={options.map((option) => ({
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "16px",
                height: "16px",
                backgroundColor: option.value,
                borderRadius: "50%",
                border: "1px solid grey",
              }}
            />
            {option.label}
          </div>
        ),
        value: option.value,
      }))}
      onChange={onChange}
    />
  </Form.Item>
);

export default FormSelectColor;
